import SupportService from 'js-promo-partners-lib/lib/services/support-service/support-service';
import httpClient from '../http-client/http-client';
import getConfig from '../../config';

const { apiUrl } = getConfig();

export default new SupportService(apiUrl, httpClient);
